module.exports = __webpack_public_path__ + ".well-known/img/merchant-logo.09116196.png";